var ElementSetter = require('./abstract/element');

module.exports = GroupSetter;

function GroupSetter () {
  this.handledAttributes = [
    'rotation',
    'opacity',
    'locked',
    'link'
  ];
}

GroupSetter.prototype = new ElementSetter();
GroupSetter.prototype.constructor = GroupSetter;
